


































import { PropSync } from "vue-property-decorator";
import BaseFilter from "@/components/Filter/BaseFilter";
import { SmppConnectionFilter } from "@/store/settings/smpp_connections/types";
import { Action } from "vuex-class";
import Component from "vue-class-component";
import {getTranslatedParams} from "@/utils/notify-utils";
import {InputWings} from "wings-ui-components";

@Component({components: {InputWings}})
export default class SmppConnectionsFilter extends BaseFilter<SmppConnectionFilter> {
  @PropSync("show") is_show!: boolean;
  @Action("getSmppConnections") actionGetSmppConnections: any;

  defaultFilter(): SmppConnectionFilter {
    return {
      name: undefined,
      description: undefined,
    };
  }

  created() {
    this.filtered();
  }

  async onFilteredAction() {
    try {
      this.logObject = {
        action_page: this.$route.meta.msgKey,
        action: "Viewing",
        action_status: "success",
        object_type: "SMPP connection",
        addititional_info: getTranslatedParams(this.filter)
      };
      await this.actionGetSmppConnections(this.filter);
      await this.actionLog(this.logObject);
    }
    catch (err){
      await this.actionLog({...this.logObject, action_status: "failed"});
    }
  }
}
